/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../../common/countries';
import './common';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "onboarding": {
        "nested": {
          "business": {
            "nested": {
              "GbBusiness": {
                "fields": {
                  "category": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "subCategory": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "companiesHouseRegistrationNumber": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "companyType": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "legalName": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "registeredAddressToken": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  },
                  "locationAddressToken": {
                    "type": "string",
                    "id": 7,
                    "rule": "optional"
                  },
                  "vatNumber": {
                    "type": "string",
                    "id": 8,
                    "rule": "optional"
                  },
                  "vatName": {
                    "type": "string",
                    "id": 9,
                    "rule": "optional"
                  },
                  "vatAddress": {
                    "type": "string",
                    "id": 10,
                    "rule": "optional"
                  },
                  "vatCountryCode": {
                    "type": ".squareup.common.countries.Country",
                    "id": 11,
                    "rule": "optional"
                  },
                  "tradingName": {
                    "type": "string",
                    "id": 12,
                    "rule": "optional"
                  },
                  "merchantAnalytic": {
                    "type": ".squareup.onboarding.business.common.MerchantAnalytic",
                    "id": 13,
                    "rule": "repeated"
                  },
                  "type": {
                    "type": ".squareup.onboarding.business.GbBusiness.Type",
                    "id": 14,
                    "rule": "optional"
                  },
                  "enteredBeneficialOwnerInformation": {
                    "type": "bool",
                    "id": 15,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "Type": {
                    "values": {
                      "UNKNOWN": 0,
                      "BUSINESS": 1,
                      "INDIVIDUAL": 2,
                      "PARTNERSHIP": 3
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.onboarding?.nested?.business?.nested?.GbBusiness && !$root.nested?.squareup?.nested?.onboarding?.nested?.business?.nested?.GbBusiness?.nested?.Type) {
  $root.addJSON(jsonData);
}

/**
 * Represents a business entity in the UK.
 *
 * SOURCE GbBusiness @ squareup/onboarding/business/gb.proto at 13:1
 */
export const GbBusiness = $root.lookupType('squareup.onboarding.business.GbBusiness');
fixType(GbBusiness);
Builder.createAndAttachToType(GbBusiness);
/**
 * SOURCE Type @ squareup/onboarding/business/gb.proto at 58:3
 */
GbBusiness.Type = $root.lookupEnum('squareup.onboarding.business.GbBusiness.Type').values;